import { Button } from '@round/ui-kit';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BookingComplete.module.css';
import { ReactComponent as TickCircle } from '../../../../../assets/TickCircle.svg';

const BookingComplete = () => {
    const navigate = useNavigate();

    return (
        <div className={styles.container}>
            <TickCircle />
            <div className={styles.body}>
                <span className={styles.title}>Booking request sent!</span>
                <p className={styles.text}>
                    Our managers will follow up shortly with confirmation that creators have confirmed their
                    participation.
                </p>
            </div>
            <div className={styles.buttonsContainer}>
                <Button
                    type="bordered"
                    color="black"
                    onClick={() => navigate(`/client/roster/`, { replace: true })}
                    className={styles.button}
                >
                    Back to Roster
                </Button>
                <Button
                    type="bordered"
                    color="black"
                    onClick={() => navigate(`/client/campaigns/`, { replace: true })}
                    className={styles.button}
                >
                    Go to Campaigns
                </Button>
            </div>
        </div>
    );
};

export default BookingComplete;
